module.exports = __webpack_public_path__ + "static/media/announcementBar-close-icon.0281d090.svg";